import getConfig from '../../config';
import { DeploymentHost } from '../../types';

const apis = getConfig(window.location.hostname as DeploymentHost);

const request = await fetch(`${apis.PB_V2_API}/wlj-lookups`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ api: "nf" })
})

let response
try {
  response = await request.json()
} catch(error) {
  console.log("error fetching national friendly occupation list")
  throw new Error(`error fetching national friendly occupation list: ${(error as Error)?.message}`)
}

export const Occupations = response.data.map((occupation: any) => {
  occupation["value"] = occupation["Id"]
  occupation["label"] = occupation["Description"]
  return occupation;
})
